export default function(data) {
  var self = this;

  self.course_id = data.id;
  self.forums_enabled = data.forums_enabled;

  self.attribs = {
    'sessions': ko.observable( true ),
    'coursework': ko.observable( true ),
    'resources': ko.observable( true ),
    'announcements': ko.observable( true ),
    'coursework_submissions': ko.observable( true ),
    'forums': ko.observable( self.forums_enabled ),
    'course_media': ko.observable( true ),
    'session_media': ko.observable( true ),
    'coursework_media': ko.observable( true ),
    'resource_media': ko.observable( true ),
  };

  self.exportBackup = function() {
    var data = ko.toJS( self.attribs );
    var request = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.course_archives_create_path( self.course_id ),
      data: { 'course_archive': data },
      dataAsJson: false,
      loadingIndicator: {
        container: $( '#main' ),
        cb: function() {},
        positionTop: 'fixed',
        message: 'Submitting...'
      }
    });

    request.done( function(data) {
      document.getElementsByClassName('js-export-backup')[0].disabled = true;
      new Kadenze.Notice.success({ message: 'Course download file is being generated. You will receive a notification once it is available.' });
      window.location.replace(Kadenze.Routes.course_path(self.course_id));
    });

    request.fail( function( xhr, textStatus, errorThrown ) {
      console.log( xhr );
      new Kadenze.Notice.error( $.extend({}, {}, { message: Kadenze.I18n.t( 'notice.unexpected_error' ) }));
    });
  };

  //var stepProgress = new Kadenze.WizardStepNav($('#js-wizardNav'), self, stepObj);

  const __construct = function( that ) {
    console.log( 'constructor called for CourseArchive' );
  }( this );

  return self;
}

